import styled from "styled-components/macro";
import { medText } from "../../../constants/colors";

export const DateRangeStyles = styled.div`
  min-height: 1.6em;
  .trendsPageDate {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0 1em;
    color: ${medText};
    width: fit-content;
    margin: auto;
    position: relative;
    .dash {
      margin-top: -6px;
      width: 3em;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &.compact {
    .trendsPageDate {
      flex-direction: column;
      box-sizing: border-box;
      .MuiFormControl-root:first-child {
        margin-bottom: 2em;
      }
      .MuiInputBase-root {
        min-width: 272px;
        width: 272px;
      }
    }
  }
  .pointerEventsNone {
    pointer-events: none;
  }
  .fadeOut {
    &.btnForward {
      transform: translateX(-20px) scale(0.25);
    }
    &.btnBack {
      transform: translateX(20px) scale(0.25);
    }
    opacity: 0;
    pointer-events: none !important;
  }
  .fadeOutTransition {
    transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .springUpDownWrapper {
    margin-top: 0;
  }
`;
